import { TieredMenuDesignTokens } from '@primeuix/themes/types/tieredmenu';

// The SplitButton dropdown renders a TieredMenu. Aura resolves it through the
// `content.*` and `navigation.*` semantic tokens, neither of which the preset
// overrides, so without this it falls back to stock Aura colours.
export const tieredMenuPreset: TieredMenuDesignTokens = {
  root: {
    borderRadius: '{borderRadius}',
    background: 'var(--background-popup)',
    borderColor: 'var(--divider-normal)',
    color: 'var(--content-neutral-primary)',
  },
  separator: {
    borderColor: 'var(--separator-primary)',
  },
  colorScheme: {
    dark: {
      item: {
        color: 'var(--content-neutral-primary)',
        focusBackground: '{nspSky.300}',
        focusColor: '{nspSlate.950}',
        activeBackground: '{nspSky.300}',
        activeColor: '{nspSlate.950}',
        icon: {
          color: 'var(--content-neutral-secondary)',
          focusColor: '{nspSlate.950}',
          activeColor: '{nspSlate.950}',
        },
      },
      submenuIcon: {
        color: 'var(--content-neutral-secondary)',
        focusColor: '{nspSlate.950}',
        activeColor: '{nspSlate.950}',
      },
    },
    light: {
      item: {
        color: 'var(--content-neutral-primary)',
        focusBackground: '{nspSky.300}',
        focusColor: '{nspSlate.950}',
        activeBackground: '{nspSky.300}',
        activeColor: '{nspSlate.950}',
        icon: {
          color: 'var(--content-secondary)',
          focusColor: '{nspSlate.950}',
          activeColor: '{nspSlate.950}',
        },
      },
      submenuIcon: {
        color: 'var(--content-secondary)',
        focusColor: '{nspSlate.950}',
        activeColor: '{nspSlate.950}',
      },
    },
  },
};
